import { useRef } from "react";
import { ArrowButton } from "../../../../../components/features/ArrowButton";
import { useTranslation } from "../../../../../lib/i18n";
import { OtherProductCard } from "../OtherProductCard";
import { ProfilerProduct } from "@/features/profiler/types/ProfilerProduct";

type RecommendedProductsProps = {
  alsoLikeFeticheFragrance: ProfilerProduct;
  alsoLikeLoubiworldFragrance: ProfilerProduct;
};

export const RecommendedProducts = ({ alsoLikeFeticheFragrance, alsoLikeLoubiworldFragrance }: RecommendedProductsProps) => {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const { t } = useTranslation();

  return (
    <>
      <div className="flex justify-between items-end self-stretch">
        <p className="text-[#050505] text-center font-minion text-[26px] font-normal">
          {t('results.fragrance.youShouldAlsoLike')}
        </p>
        <ArrowButton
          ariaLabel={t('scrollProductsRight')}
          scrollContainerRef={scrollContainerRef}
        />
      </div>
      <div className="w-full pb-10">
        <div ref={scrollContainerRef} className="flex gap-4 overflow-x-auto">
          <OtherProductCard
            name={alsoLikeFeticheFragrance.label}
            imagePath={`/fragrance-profiler/secondary-fragrances/${alsoLikeFeticheFragrance.id}.avif`}
            watchTutorial={false}
          />
          <OtherProductCard
            name={alsoLikeLoubiworldFragrance.label}
            imagePath={`/fragrance-profiler/secondary-fragrances/${alsoLikeLoubiworldFragrance.id}.avif`}
            watchTutorial={false}
          />
        </div>
      </div>
    </>
  );
};
